import { BaseSyntheticEvent, useContext, useState } from "react";
import { IoAddCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { LoadingContext } from "../../../../contexts/Loading/LoadingContext";
import { api, errorTreatment } from "../../../../services/api";
import AddNewPageModal from "../AddNewPageModal";
import TooltipConfig from "../../../../components/Tooltip";

const AddNewPage = ({
  modal,
  modalAddPageShow,
  description,
}: {
  modal: boolean;
  modalAddPageShow?: boolean;
  description?: string;
}) => {
  const { changeVisibility } = useContext(LoadingContext);
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(modalAddPageShow ?? false);
  const [templateShow, setTemplateShow] = useState(false);

  const add = () => {
    changeVisibility(true);
    Promise.all([api.post("/dashboards/configurations", {})])
      .then(([responseAdd]: [{ data: { id: string } }]) => {
        changeVisibility(false);
        navigate(`/dashboard/edit/${responseAdd.data.id}/new`);
      })
      .catch((error) => {
        errorTreatment(error);
      });
  };

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }
  return (
    <>
      <div
        className="user-page add-new-page"
        id="addNewPage"
        onClick={() => {
          setTemplateShow(!templateShow), modal ? setModalShow(true) : add();
        }}
        onMouseOver={MouseOver}
      >
        <div className="user-page-div">
          <div>
            <h4>
              {modal
                ? "Adicionar ou importar nova página"
                : "Adicionar nova página"}
            </h4>
          </div>
          <div style={modal ? { padding: "0px" } : { padding: "10px" }}>
            <TooltipConfig
              content={
                modal ? ["Adicionar nova página"] : ["Adicionar página vazia"]
              }
              children={<IoAddCircleOutline size={modal ? 50 : 80} />}
              placement={"bottom"}
              style={true}
            />
          </div>
          <div id="user-page-description">{description}</div>
        </div>
      </div>
      <AddNewPageModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
      />
    </>
  );
};

export default AddNewPage;
